import PlantIcon from './PlantIcon';

export default PlantIcon;